const externalInits = () => {
    const splitElems = document.querySelectorAll('.js-split-text');

    splitElems.forEach((elem, i) => {
        // Add iteration class to make split elem unique
        elem.classList.add('js-split-text-' + (i + 1));

        const splitTarget = '.js-split-text-' + (i + 1);
        const splitLines = Splitting({ target: splitTarget, by: 'lines' });
        const lines = splitLines[0].lines;
        let innerHTML = '';

        lines.forEach((line, x) => {
            innerHTML += '<div class="js-split-text-line js-split-text-line-' + (x + 1) + '">';
            
            line.forEach((word, index) => { 
                const wordText = word.getAttribute('data-word');
                
                innerHTML += '<span>' + wordText + '</span>';

                if ( (index + 1) < line.length ) {
                    innerHTML += '<span class="whitespace">&nbsp;</span>';
                }
            });

            innerHTML += '</div>';
        });

        $(splitTarget).html(innerHTML);
    });

    // Hero Section -- Image
    slickInit('.js__hero-section-image-slider', false, {
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
        fade: true,
        speed: 600,
        cssEase: 'linear'
    });

    // Hero Section -- Content
    slickInit('.js-hero-section-content-slider', true, {
        dots: true,
        // appendDots: $('.hero-section__slider-nav'),
        dotsClass: 'slick-dots | d-flex order-2',
        arrows: true,
        prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
        nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
        // appendArrows: $('.hero-section__slider-nav'),
        autoplay: true,
        autoplaySpeed: 3500,
        fade: true,
        speed: 600,
        cssEase: 'linear'
    });

    // Content & Image Block -- Content
    slickInit('.js-ci-block-content-slider', true, {
        dots: true,
        // appendDots: $('.ci-block__slider-nav'),
        dotsClass: 'slick-dots | d-flex order-2',
        arrows: true,
        prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
        nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
        // appendArrows: $('.ci-block__slider-nav')
    });
};

const slickInit = (elem, sliderNav = false, settings) => {
    const sliderElems = document.querySelectorAll(elem);
    const sliderClass = elem.replace('.', '');

    if ( sliderElems.length ) {
        sliderElems.forEach((sliderElem, i) => {
            // Add iteration class to make slider unique
            sliderElem.classList.add(sliderClass + '-' + (i + 1));
            const slider = '.' + sliderClass + '-' + (i + 1);

            // Add the custom slider nav positions if sliderNav is passed thorugh as true
            if ( sliderNav ) {
                const sliderNavElem = $(slider).closest('section').find('.c-slider-nav');

                settings.appendDots = sliderNavElem;
                settings.appendArrows = sliderNavElem;
            }

            // Init the slider
            $(slider).slick(settings);
        });
    }
};

const getSliderArrows = (arrowType) => {
    const prevArrow = '<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="e-svg"><path d="M7.78272 10.9865L1.01349 6.16111C0.882922 6.06513 0.796603 5.92224 0.773521 5.76388C0.75044 5.60551 0.792487 5.44465 0.890413 5.31667L1.01349 5.19603L7.78272 0.370638C7.96919 0.233559 8.21868 0.211509 8.42716 0.313682C8.63564 0.415855 8.76733 0.624712 8.76733 0.853178V10.504C8.76733 10.8371 8.49182 11.1071 8.15195 11.1071L7.78272 10.9865Z" fill="#F9F0E3" class="e-svg__fill"/></svg>';
    const nextArrow = '<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="e-svg"><path d="M1.75195 0.513492L8.52118 5.33889C8.65175 5.43487 8.73807 5.57776 8.76115 5.73613C8.78423 5.89449 8.74218 6.05535 8.64426 6.18333L8.52118 6.30397L1.75195 11.1294C1.56548 11.2664 1.31599 11.2885 1.10751 11.1863C0.899028 11.0841 0.767334 10.8753 0.767334 10.6468L0.767335 0.996032C0.767335 0.662908 1.04285 0.392858 1.38272 0.392858L1.75195 0.513492Z" fill="#F9F0E3" class="e-svg__fill"/></svg>';

    if ( arrowType == 'prev' ) {
        return prevArrow;
    }
    if ( arrowType == 'next' ) {
        return nextArrow;
    }

    return ''; // Return an empty string if no matches for arrowType
};